export type SystemApp = {
  id: string
  name: string
  icon: string
  link: string
  visibility: 'authenticated' | 'admin'
  category: 'system' | 'management'
  order: number
}

export const coreSystemApps: SystemApp[] = [
  {
    id: 'settings',
    name: 'Settings',
    icon: 'ri-settings-3-line',
    link: '/settings',
    visibility: 'authenticated',
    category: 'system',
    order: 100,
  },
  {
    id: 'profile',
    name: 'Profile',
    icon: 'ri-user-line',
    link: '/profile',
    visibility: 'authenticated',
    category: 'system',
    order: 101,
  },
]
